module.exports = __webpack_public_path__ + "static/media/SIPL.7d4bbd93.webp";